import { NavLink } from 'react-router-dom';

/**
 * Settings sub-navigation (the /settings/* sidebar tabs).
 *
 * Public interface: a list of already-filtered `items`. Hides the
 * `<aside className="settings-subnav">` structure, the NavLink active-class
 * contract (`settings-subnav-link` / `settings-subnav-link-active`), and the
 * per-link icon + label markup.
 *
 * Visibility (e.g. admin-only links) is the caller's responsibility — pass only
 * the items that should be shown.
 *
 * Props:
 *   items     — Array<{ to: string, label: node, icon?: ComponentType }>
 *   ariaLabel — accessible label for the nav region (default 'Settings sections')
 *   className — extra class(es) on the <aside>
 */
export default function SettingsTabs({
  items = [],
  ariaLabel = 'Settings sections',
  className = '',
}) {
  const linkClass = ({ isActive }) =>
    `settings-subnav-link ${isActive ? 'settings-subnav-link-active' : ''}`;

  return (
    <aside
      className={['settings-subnav', className].filter(Boolean).join(' ')}
      aria-label={ariaLabel}
    >
      {items.map(({ to, label, icon: Icon }) => (
        <NavLink key={to} to={to} className={linkClass}>
          {Icon && <Icon size={18} className="settings-subnav-icon" aria-hidden />}
          <span>{label}</span>
        </NavLink>
      ))}
    </aside>
  );
}
